import { render } from "./send-loa.vue?vue&type=template&id=08bb5160&scoped=true"
import script from "./send-loa.vue?vue&type=script&lang=js"
export * from "./send-loa.vue?vue&type=script&lang=js"

import "./send-loa.vue?vue&type=style&index=0&id=08bb5160&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bb5160"]])

export default __exports__